export type WizardInput = {
  step: number;
  clientId: string;
  name: string;
  packageName: string | null;
  hours: string;
  chf: string;
  templateId: string;
  goLive: string | null;
  mappedRoles: number;
};

/** Whether the New project dialog holds anything the person typed or chose, so closing it should ask first. */
export function isWizardDirty(w: WizardInput): boolean {
  return w.step > 0 || w.clientId !== "" || w.name !== "" || w.packageName !== null || w.hours !== "" || w.chf !== "" || w.templateId !== "" || w.goLive !== null || w.mappedRoles > 0;
}
